import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            Haja Saúde Fisio
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#objetivos" className="page-scroll">
                Objetivos
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                Quem somos
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Especialidades
              </a>
            </li>
            <li>
              <a href="#physiotherapy" className="page-scroll">
                Fisioterapia
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Ot. Especialidades
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                Testemunhos
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll">
                Equipa
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contactos
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
